import vue from 'vue';
import axios from 'axios';
/*eslint-disable*/
import qs from 'qs';
import { getCookieForRoleTag, getCookieKeyForRoleTag, getQueryVariable, getTokenForRoleTag } from "./ulit";
import { encrypted } from "./validate";
import APIDOC from "./serverApi";
export const baseUrl = APIDOC.BASEURL;
// 拦截请求操作
function transformRequest(data, header) {
    //获取token 统一设置
    const tokenForRoleTag = getCookieForRoleTag();
    // const token = vue.prototype.$cookies.get("JT_S_02_token");
    // const token = localStorage.getItem(getStorageKeyForRoleTag('TOKEN'));
    if (tokenForRoleTag) {
        header.common['token'] = tokenForRoleTag;
        header.common["_role_tag"] = getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null;
    }

    //获取isWx 统一设置 是否是微信浏览器
    const isWx = localStorage.getItem('isWx');
    if (isWx) {
        header.common['isWx'] = isWx;
    }
    // 做兼容处理， 图片上传的为multipart/form-data
    if (header['Content-Type'] === 'multipart/form-data;charset=UTF-8') {
        return data;
    }
    if (['application/json;charset=UTF-8'].indexOf(header['Content-Type']) >= 0) {
        return JSON.stringify(data);
    }

    return qs.stringify(data);
    // return JSON.stringify(data);
}

// 拦截响应操作
function transformResponse(data) {
    // todo
    return data;
}

const instance = axios.create({
    baseUrl: '',
    timeout: 60000,
    transformRequest: [transformRequest],
    transformResponse: [transformResponse],
})

const _context = vue.prototype;

//const Version = "?v_n=1.0.1";//请求加上版本号   如：?version=1.0.1
const Version = "";//请求加上版本号   如：?version=1.0.1

// 拦截请求
instance.interceptors.request.use((config) => {
    // todo
    return config;
},
    (error) => Promise.reject(error));
// 拦截响应
instance.interceptors.response.use((response) => {
    // 数据返回成功
    // 统一对401 登录过期处理
    let data = null;
    if (typeof response.data === 'string' && response.data.trim() !== "") {
        data = JSON.parse(response.data);
        // console.log(response.config.url.indexOf("/leaning.do"))
        /**
         * 接口调用成功，如果调用的是leaning.do或者getGrades.do接口。调用getClientNeedStudyLog.do接口，
         * 且额外传一个参数triggerSource用来记录是哪个接口触发的
         */
        if(data.code == 0){ // 调用成功
            if(response.config.url.indexOf("/leaning.do") >= 0){
                _context.$getClientNeedStudyLog('','','/leaning.do');
            }else if(response.config.url.indexOf("/getGrades.do") >=0){
                _context.$getClientNeedStudyLog('','','/getGrades.do');
            }
            if(response.config.url.indexOf("/getMessageAccept.do") < 0 ){
                const match = response.config.url.match(/^(?:.*\/)?([^\/?]*)(?=\?|$)/);
                _context.$APInterface(match ? match[1] : null);
            }
        }
    } else {
        data = response;
    }
    return Promise.resolve(data);
},
    error => {
        if (error.response) {
            let ret = JSON.parse(error.response.data);
            if (ret.code == 401) {
                _context.$message({
                    message: ret.msg,
                    type: 'warning'
                });
                setTimeout(function () {
                    // this.$cookies.remove("JT_S_02_token")
                    this.$cookies.remove(getCookieKeyForRoleTag());
                    window.location.href = vue.prototype.$baseUrl;
                    // localStorage.removeItem('TOKEN');
                    // window.location.href = window.location.origin;
                }, 500);
            } else {
                _context.$message({
                    message: ret.msg,
                    type: 'error'
                });
            }
        }
        return Promise.reject(error)
    });

// 导出两个操作
// get 操作
export function get(url, params, option) {
    return new Promise((resolve, reject) => {
        instance.get(url + "?s_=" + encrypted(), {
            params,
            ...option,
        })
            .then((ret) => {
                // todo
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}

// post 操作
export function post(url, params, option) {
    return new Promise((resolve, reject) => {
        instance.post(url + "?s_=" + encrypted(), params, option)
            .then((ret) => {
                // todo
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}
// post 操作
export function postJSON(url, params, option) {
    return new Promise((resolve, reject) => {
        instance.post(url + "?s_=" + encrypted(), params,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                }, ...option
            })
            .then((ret) => {
                // todo
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}
export function postFormData(url, formdata, option) {
    return new Promise((resolve, reject) => {
        instance.post(url + "?s_=" + encrypted(), formdata,
            {
                headers: {
                    'Content-Type': 'multipart/form-data;charset=UTF-8',
                }, ...option
            })
            .then((ret) => {
                // todo
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}

//post


function getParamsPathStr(obj) {
    const timeStamp = '_t=' + new Date().getTime();
    let str = '?';
    for (const key in obj) {
        const tempStr = '' + key + '=' + obj[key] + '&';
        str += tempStr;
    }
    str.indexOf('&') === -1 ? str = timeStamp : str += timeStamp;
    return str;
}

/*
* post 操作，将参数拼接在地址栏后
* 2023年7月5日 14:20:31
* */
export function postParams(url, params, option) {
    return new Promise((resolve, reject) => {
        instance.post(url + getParamsPathStr(params), undefined,
            { headers: { 'Content-Type': 'application/json;charset=UTF-8' }, ...option })
            .then((ret) => {
                // todo
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}



/*
* 2023年7月6日 16:49:53
* headers: {'Content-Type': 'multipart/form-data'},
* */
export function upload_64(base64, option = {}) {
    const path = APIDOC.UPLOAD_64;
    const params = { baseStr: (base64) };
    // console.log("upload api", path, base64)
    return new Promise((resolve, reject) => {
        instance.post(path, params,
            {
                ...option,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            })
            .then((ret) => {
                resolve(ret);
            })
            .catch((err) => {
                // todo
                reject(err);
            });
    });
}



// WEBPACK FOOTER //
// ./src/common/request.js